export default __webpack_public_path__ + "static/media/Awards_BG-02.5a4ad64b.png";